<template>
  <div id="mapLamar"></div>
</template>

<style>
#mapLamar {
  width: 100%;
  height: 450px;
  z-index: 1;
  border-radius: 10px;
}
</style>

<script>
import leaflet from "leaflet";
import "leaflet/dist/leaflet.css";
import { onMounted } from "vue";
export default {
  setup() {
    let mymap;
    onMounted(() => {
      const icon = leaflet.icon({
        iconUrl: require("@/assets/icons/Mark.svg"),
        iconSize: [28, 28],
      });

      const marks = [
        {
          name: "Estación Meteorológica Automática",
          lat: -12.0401,
          lng: -75.3205,
        },
        { name: "Torre de gradientes", lat: -12.0399, lng: -75.3208 },
        { name: "Estación BSRN", lat: -12.0424, lng: -75.3189 },
        { name: "Fotómetro Solar", lat: -12.0402, lng: -75.321 },
        { name: "Ceilómetro", lat: -12.0402, lng: -75.3209 },
        { name: "Disdrómetro", lat: -12.0403, lng: -75.3206 },
        { name: "Radar MIRA-35C", lat: -12.0403, lng: -75.3209 },
        { name: "Radar de capa límite-BLTR", lat: -12.0412, lng: -75.3193 },
        { name: "Radiómetro UV", lat: -12.0412, lng: -75.3196 },
        { name: "Pluviómetro de peso", lat: -12.0402, lng: -75.3206 },
        { name: "Radar CLAIRE", lat: -12.0401, lng: -75.321 },
      ].map(({ name, lat, lng }) => ({
        name,
        latLng: [lat, lng],
      }));

      const tileLayer = [
        {
          name:
            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        },

        {
          name:
            "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
        },
      ];

      mymap = leaflet.map("mapLamar").setView([-12.04125, -75.31955556], 17);

      tileLayer.forEach((tile) => {
        leaflet
          .tileLayer(tile.name, {
            maxZoom: 17,
            minZoom: 15,
            attribution: "Instituto Geofísico del Perú",
          })
          .addTo(mymap);
      });

      marks.forEach((mark) => {
        leaflet
          .marker(mark.latLng, { icon: icon })
          .bindPopup(mark.name)
          .openPopup()
          .addTo(mymap);
      });
    });
  },
};
</script>
